import { atom } from "recoil"


export const financeCardDetailLayerController = atom({
	key: "financeCardDetailLayerController",
	default: {
		show: false,
		cardId: undefined
	}
})

export const financeSavingDetailState_1 = atom({
	key: "financeSavingDetailState_1",
	default: {
		show: false
	}
})

export const financeSavingDetailState_2 = atom({
	key: "financeSavingDetailState_2",
	default: {
		show: false
	}
})

export const financeSavingDetailState_3 = atom({
	key: "financeSavingDetailState_3",
	default: {
		show: false
	}
})

export const financeLoanDetailState_1 = atom({
	key: "financeLoanDetailState_1",
	default: {
		show: false
	}
})

export const financeLoanDetailState_2 = atom({
	key: "financeLoanDetailState_2",
	default: {
		show: false
	}
})

export const financeLoanDetailState_3 = atom({
	key: "financeLoanDetailState_3",
	default: {
		show: false
	}
})

export const financeProductTypeState = atom({
	key: "financeProductTypeState",
	default: undefined
})

export const benefitCardLayerShowState = atom({
	key: "benefitCardLayerShowState",
	default: false
})

export const govIntroLayerShowState = atom({
	key: "govIntroLayerShowState",
	default: false
})